/**
 * Apollo cache
 */

import { getDynamicUsersByRoleListPolicy } from '@core/apollo/cache/typePolicies/query/getDynamicUsersByRoleList';

const typePolicies = {
  Query: {
    fields: {
      getDynamicUsersByRoleList: getDynamicUsersByRoleListPolicy,
    },
  },
};

export { typePolicies };
